import './index.css';

import {App} from 'antd';
import React from 'react';
import ReactDOM from 'react-dom/client';

import {AppContext} from './AppContext';
import {AuthProvider} from './AuthContext';
import {ApiRuntime, BaseAPI} from './gen/api/runtime';
import MainApp from './MainApp';
import {NotificationProvider} from './NotificationContext';
import reportWebVitals from './reportWebVitals';
import {ResponsiveGate} from './ResponsiveGate';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

BaseAPI.withPreMiddleware((context) => {
    context.init.credentials = 'include';

    return Promise.resolve(context);
});
const initToken = localStorage.getItem('token');
if (initToken !== null) {
    ApiRuntime.setApiKey(initToken);
}

root.render(
    <ResponsiveGate>
        <App style={{minHeight: '100vh'}}>
            <AppContext>
                <AuthProvider>
                    <NotificationProvider>
                        <MainApp />
                    </NotificationProvider>
                </AuthProvider>
            </AppContext>
        </App>
    </ResponsiveGate>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
